import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2b851d74&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b851d74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/Temperature/TempAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b851d74')) {
      api.createRecord('2b851d74', component.options)
    } else {
      api.reload('2b851d74', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2b851d74&scoped=true&", function () {
      api.rerender('2b851d74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/reports/static/index.vue"
export default component.exports